<template>
  <el-dialog :title="title" v-dialogDrag :visible.sync="processDialogVisiable" width="980px">
    <el-form label-width="100px">
      <el-form-item label="名称">
        <el-input
          type="text"
          v-model="handleProcessName"
          placeholder="请输入流程名称"
          :disabled="type === 3"
        ></el-input>
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="流程类型" style="width: 50%">
        <el-select v-model="handleProcessType" style="width: 100%" :disabled="type === 3">
          <el-option
            v-for="item in processTypeDic"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子流程类型" style="width: 50%">
        <el-select v-model="subHandleProcessType" style="width: 100%" :disabled="type === 3">
          <el-option 
            v-for="item in subProcessTypeDic"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      </div>
      <el-form-item label="现场处置说明" class="editorWrapper">
        <editor ref="wEditor" :content="handleProcessBase64" :type="type" />
      </el-form-item>
      <el-form-item label="简化流程说明" class="editorWrapper">
        <editor ref="simpleProcessEditor" :content="simpleProcessBase64" :type="type" />
      </el-form-item>
      <div style>
        <el-form-item label="说明">
          <el-input
            type="textarea"
            v-model="desc"
            :disabled="type === 3"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer" v-if="type !== 3">
      <el-button type="primary" @click="handleSave">保存</el-button>
      <el-button type="info" @click="handleCancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Editor from "./editor";
import api from "../api";
import { Dic } from "$utils";
export default {
  components: { Editor },
  data() {
    return {
      // 处置类型
      processTypeDic: Dic.find("SENU073003"),
      // 子处置类型
      subProcessTypeDic: Dic.find("SENU073004"),
      handleProcessType: '',
      subHandleProcessType: '',
      processDialogVisiable: false,
      // 处置流程
      handleProcessBase64: "",
      // 简化流程
      simpleProcessBase64: "",
      // 流程名称
      handleProcessName: "",
      // 流程描述
      desc: "",
      title: "",
      type: 1,
    };
  },
  mounted() {
    // console.log(this.processTypeDic);
    // console.log(this.subProcessTypeDic);
  },
  watch: {
    processDialogVisiable(newVal) {
      // 清空数据
      if (!newVal) {
        this.handleProcessBase64 = '';
        this.handleProcessName = '';
        this.desc = '';
        this.simpleProcessBase64 = ''
        this.handleProcessType = ''
        this.subHandleProcessType = ''
        this.$refs.wEditor.editor.txt.html('');
        this.$refs.simpleProcessEditor.editor.txt.html('')
      }
    },
  },
  methods: {
    encodeBase64(str) {
      const encode = encodeURI(str);
      // 对编码的字符串转化base64
      const base64 = btoa(encode);
      return base64;
    },
    decodeBase64(base64) {
      // 对base64转编码
      const decode = atob(base64);
      const str = decodeURI(decode);
      return str;
    },
    toggleVisible(type) {
      this.processDialogVisiable = true;
      // 查看详情禁用richEditor
      if (type === 3) {
        this.$nextTick(() => {
          this.$refs.wEditor.editor.disable();
          this.$refs.simpleProcessEditor.editor.disable()
        });
      } else {
        console.log("enable");
        this.$nextTick(() => {
          this.$refs.wEditor.editor.enable();
          this.$refs.simpleProcessEditor.editor.enable()
        });
      }

      this.type = type;
      this.title =
        type === 1
          ? '新增' // this.$t("emergencyHandle.modal.add")
          : type === 2
          ? '修改' // this.$t("emergencyHandle.modal.update")
          : '详情' // this.$t("emergencyHandle.modal.detail");
    },
    getDetailData(data) {
      
      try {
        const {
          handleProcessBase64,
          simpleProcessBase64,
          handleProcessName,
          desc,
          handleProcessCode,
          handleProcessType,
          subHandleProcessType
        } = data;
        this.$nextTick(() => {
          this.handleProcessBase64 = this.decodeBase64(handleProcessBase64);
          this.simpleProcessBase64 = this.decodeBase64(simpleProcessBase64)
          this.handleProcessName = handleProcessName;
          this.desc = desc;
          this.handleProcessCode = handleProcessCode
          this.handleProcessType = parseInt(handleProcessType)
          this.subHandleProcessType = parseInt(subHandleProcessType)
        })
        // console.log(this.simpleProcessBase64, 'subbb')
      } catch (error) {
        console.error(error);
      }
    },
    async handleSave() {
      const handleProcessBase64 = this.encodeBase64(
        this.$refs.wEditor.curContent
      );
      const simpleProcessBase64 = this.encodeBase64(
        this.$refs.simpleProcessEditor.curContent 
      )
      const params = {
        handleProcessBase64,
        simpleProcessBase64,
        handleProcessType: this.handleProcessType + '',
        subHandleProcessType: this.subHandleProcessType + '',
        handleProcessName: this.handleProcessName,
        desc: this.desc,
      };
      if (this.type == 2) {
        params.handleProcessCode = this.handleProcessCode;
      } else {
        delete params.handleProcessCode;
      }
      const realApi =
        this.type === 1
          ? api.addEmergencyHandleProcess
          : api.updateEmergencyHandleProcess;
      try {
        const { success, msgContent } = await this.$fetch(realApi, params);
        if (success) {
          this.processDialogVisiable = false;
          this.$emit("save-success");
        } else {
          msgContent && this.$message.warning(msgContent);
        }
      } catch (err) {
        console.error(err);
      }
    },
    handleCancel() {
      this.processDialogVisiable = false
      // 处置流程
      this.handleProcessBase64 = ''
      this.simpleProcessBase64 = ''
      this.handleProcessType = ''
      this.subHandleProcessType = ''
      // 流程名称
      this.handleProcessName = ''
      // 流程描述
      this.desc = ''
    },
  },
};
</script>

<style></style>
